import { render, staticRenderFns } from "./LongTextSettings.vue?vue&type=template&id=79191422&scoped=true"
import script from "./LongTextSettings.vue?vue&type=script&lang=js"
export * from "./LongTextSettings.vue?vue&type=script&lang=js"
import style0 from "./LongTextSettings.vue?vue&type=style&index=0&id=79191422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79191422",
  null
  
)

export default component.exports